import { useState } from 'react';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Box from '@mui/material/Box';
import TextInput from '../../common/fields/text-field';
import Button from '@mui/material/Button';
import { FIELD_TYPES, Field } from '../../../types';
import { useStringsContext } from '../../../contexts/strings';
import { SxStyle } from '../../../types';

const styles: SxStyle = {
  closeButton: (theme) => ({
    position: 'absolute',
    right: '8px',
    top: '8px',
    color: theme.palette.grey[500],
  }),
  content: {
    height: '70px',
    display: 'flex',
    alignItems: 'center',
  },
  buttons: (theme) => ({
    borderTop: '1px solid',
    borderTopColor: theme.palette.divider,
  }),
};

interface MappingDialogProps extends DialogProps {
  open: boolean;
  onClose: () => void;
  onSave: (idOrAbbrv: string) => void;
}

const MappingDialog = ({ open, onClose, onSave }: MappingDialogProps) => {
  const { strings } = useStringsContext();
  const [idOrAbbrv, setIdOrAbbrv] = useState('');

  const onChange = (field: Field, value: string) => {
    setIdOrAbbrv(value);
  };

  return (
    <Dialog open={open} maxWidth={'sm'} fullWidth>
      <DialogTitle>
        {strings.mappings.addRow}
        <IconButton aria-label="close" onClick={onClose} sx={styles.closeButton}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box sx={styles.content}>
          <TextInput
            setChange={onChange}
            setValidation={() => {}}
            field={{
              title: strings.mappings.addIdOrAbbrv,
              id: 'id',
              type: FIELD_TYPES.TEXT,
              key: 'id',
              value: idOrAbbrv,
            }}
            key="id"
            fullWidth
          />
        </Box>
      </DialogContent>
      <DialogActions sx={styles.buttons}>
        <Button color="primary" onClick={onClose}>
          {strings.actions.cancel}
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => onSave(idOrAbbrv)}
          disabled={!idOrAbbrv}
        >
          {strings.actions.save}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MappingDialog;
